module.exports = __webpack_public_path__ + "img/img1.b708a4b6.png";